//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    src: { type: String, required: true },
    srcset: { type: String, default: '' },
    loadingImg: { type: String, default: '' },
    alt: { type: String, default: '' },
    doNotLazyLoad: { type: Boolean, default: false },
    placeholderRatio: { type: String, default: '' },
    embed: { type: Boolean, default: false }
  },
  data () {
    return {
      loaded: false,
      complete: false
    }
  },
  watch: {
    src () {
      this.loaded = false
      this.complete = false
      this.$emit('change')

      this.$nextTick(() => {
        this.checkComplete()
      })
    }
  },
  mounted () {
    this.$Lazyload.$on('loaded', this.lazyListener)
    this.checkComplete()
  },
  beforeDestroy () {
    this.$Lazyload.$off('loaded', this.lazyListener)
  },
  methods: {
    lazyListener (event) {
      if (event.src === this.resolvedSrc) {
        this.$emit('load')
        this.loaded = true
      }
    },
    loadListener () {
      this.checkComplete()
    },
    checkComplete () {
      this.complete = (this.$refs.img || {}).complete || false
    },
    addCacheSuffix (src) {
      return `${src}${src.includes('?') ? '&' : '?'}c=${this.$config.sha}`
    },
    resolve (src) {
      if (!src) return ''
      if (src.startsWith('http') || src.startsWith('//')) return this.addCacheSuffix(src)
      if (this.embed) {
        return require(`~/assets/images${src.startsWith('/') ? '' : '/'}${src}`)
      }
      return this.addCacheSuffix(`${this.$config.staticAssetURL}/images${src.startsWith('/') ? '' : '/'}${src}`)
    }
  }
}
